/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import CustomModal from "../../../../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../../../../Core/Components/CustomRoundedImage";
import CloseIcon from "../../../../../Common/Svgs/CloseIcon";
import Button from "../../../../../Core/Components/CustomButton";
import UserIcon from "../../../../../Common/Svgs/UserIcon";
import TransferTripDropdown from "./TransferTripDropdown";
import { client } from "../../../../../Utils/axiosClient";

// const LOCAL_DEFAULT_LIMIT = 10;

const ReassignTimeoffModal = ({
  visible,
  onCancel,
  // driversCurrentPage,
  // setDriversCurrentPage,
}) => {
  // const dispatch = useDispatch();

  const { loading, transferTimeoffModal } = useSelector((state) => state.users);

  const [transferToDriver, setTransferToDriver] = useState({
    id: 0,
    firstName: "",
    lastName: "",
  });

  const handleCancel = () => {
    setTransferToDriver({ id: 0, firstName: "", lastName: "" });
    onCancel();
  };

  const onReassignAndDelete = async () => {
    if (transferToDriver.id === 0) return;

    try {
      await client.put(`${process.env.REACT_APP_API_URL}/drivers/reassign`, {
        fromDriverId: Number(transferTimeoffModal.driverId),
        toDriverId: Number(transferToDriver.id),
        timeoffId: Number(transferTimeoffModal.timeoffId),
      });
    } catch (e) {
      console.log("Error while reassigning: ", e);
    }

    handleCancel();
  };

  return (
    <CustomModal
      visible={visible}
      onCancel={handleCancel}
      width="536px"
      centered
      zIndex={3000}
    >
      <div className="w-full p-4 rounded-md bg-background-white">
        <div className="flex items-center justify-between">
          <div className="relative">
            <CustomRoundedImage
              size="w-12 h-12"
              image={<UserIcon className="stroke-white fill-none" />}
              background="bg-primary"
            />
          </div>

          <button type="button" onClick={handleCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <div className="px-2 mt-5 mb-4">
          <p className="text-base font-medium text-black font-poppins">
            Re-assign{" "}
            {transferTimeoffModal.trips > 0 && transferTimeoffModal.sessions > 0
              ? "Trips and Sessions"
              : transferTimeoffModal.trips > 0
              ? "Trips"
              : transferTimeoffModal.sessions > 0
              ? "Sessions"
              : "Items"}
          </p>

          <p className="mt-1.5 text-xs font-normal text-black font-aileron">
            {transferTimeoffModal.trips > 0 && transferTimeoffModal.sessions > 0
              ? "Please re-assign the trips and sessions to another driver before approving this request."
              : transferTimeoffModal.trips > 0
              ? "Please re-assign the trips to another driver before approving this request."
              : transferTimeoffModal.sessions > 0
              ? "Please re-assign the sessions to another driver before approving this request."
              : "No trips or sessions to re-assign."}
          </p>

          <TransferTripDropdown
            transferToDriver={transferToDriver}
            setTransferToDriver={setTransferToDriver}
          />
        </div>

        <div className="flex justify-end gap-x-3 px-2 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>

          <button
            type="button"
            disabled={loading || transferToDriver?.id === 0}
            className={`px-4 py-3 h-10.5 text-white rounded-md
            ${
              transferToDriver?.id === 0
                ? "bg-[#B1B1B1] cursor-not-allowed"
                : loading
                ? "bg-alert-red-hover cursor-not-allowed"
                : "bg-alert-red hover:bg-alert-red-hover cursor-pointer"
            }
            `}
            onClick={onReassignAndDelete}
          >
            <p className="font-poppins text-xs font-medium capitalize">
              Re-Assign & Approve
            </p>
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default ReassignTimeoffModal;
